import * as types from '../constants/actionTypes';

// Fetch all firm names with optional filters
export const fetchFirmNamesRequest = (filters = {}) => ({
  type: types.FETCH_FIRM_NAMES_REQUEST,
  payload: filters
});

export const fetchFirmNamesSuccess = (data) => ({
  type: types.FETCH_FIRM_NAMES_SUCCESS,
  payload: data
});

export const fetchFirmNamesFailure = (error) => ({
  type: types.FETCH_FIRM_NAMES_FAILURE,
  payload: error
});

// Fetch active firm names only
export const fetchActiveFirmNamesRequest = () => ({
  type: types.FETCH_ACTIVE_FIRM_NAMES_REQUEST
});

export const fetchActiveFirmNamesSuccess = (data) => ({
  type: types.FETCH_ACTIVE_FIRM_NAMES_SUCCESS,
  payload: data
});

export const fetchActiveFirmNamesFailure = (error) => ({
  type: types.FETCH_ACTIVE_FIRM_NAMES_FAILURE,
  payload: error
});

// Get single firm name
export const getFirmNameRequest = (id) => ({
  type: types.GET_FIRM_NAME_REQUEST,
  payload: id
});

export const getFirmNameSuccess = (data) => ({
  type: types.GET_FIRM_NAME_SUCCESS,
  payload: data
});

export const getFirmNameFailure = (error) => ({
  type: types.GET_FIRM_NAME_FAILURE,
  payload: error
});

// Create firm name
export const createFirmNameRequest = (firmData) => ({
  type: types.CREATE_FIRM_NAME_REQUEST,
  payload: firmData
});

export const createFirmNameSuccess = (data) => ({
  type: types.CREATE_FIRM_NAME_SUCCESS,
  payload: data
});

export const createFirmNameFailure = (error) => ({
  type: types.CREATE_FIRM_NAME_FAILURE,
  payload: error
});

// Update firm name
export const updateFirmNameRequest = (id, firmData) => ({
  type: types.UPDATE_FIRM_NAME_REQUEST,
  payload: { id, firmData }
});

export const updateFirmNameSuccess = (data) => ({
  type: types.UPDATE_FIRM_NAME_SUCCESS,
  payload: data
});

export const updateFirmNameFailure = (error) => ({
  type: types.UPDATE_FIRM_NAME_FAILURE,
  payload: error
});

// Set editing firm name
export const setFirmNameEditing = (firmName) => ({
  type: types.SET_FIRM_NAME_EDITING,
  payload: firmName
});

// Clear editing firm name
export const clearFirmNameEditing = () => ({
  type: types.CLEAR_FIRM_NAME_EDITING
});
